/* eslint-disable key-spacing */
import React from 'react';

import { Docked } from '@/ui/dialogs/Dialog';
import ByDateDialog from './ByDateDialog';
import ResultsByDateDialog from './ResultsByDateDialog';
import CountryListDialog from '@/nikeone/components/dialog/CountryListDialog';

export const docked = Dialog => popup => (
    <Docked className="nikeone-filter">
        <Dialog data={popup.get('data')} />
    </Docked>
);

export const dialogs = {
    'nikeone/timeFilter': docked(ByDateDialog),
    'nikeone/country-filter': docked(CountryListDialog),
    'nikeone/results-by-date-filter': docked(ResultsByDateDialog)
};
